import React from 'react'
import { Button, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import { ToastContainer, ToastMessage } from 'react-toastr';
import TextareaAutosize from '../forms/TextareaAutosize';

import JarvisWidget from '../layout/widgets/JarvisWidget.jsx'

const ToastMessageFactory = React.createFactory(ToastMessage.animation);

let PushSender = React.createClass({

  getInitialState: function () {
    return {
      title: '',
      body: '',
      os: 0,
      bodyLength: 0,
      sendButtonTxt: 'Send',
      buttonDisabled: false,
      isNotification: 'checked',
      isTest: 'checked'
    }
  },
  handleTitleChange: function (e) {
    this.setState({ title: e.target.value });
  },
  handleBodyChange: function (e) {
    var body = e.target.value;

    if(e.target.value.length > this.props.maxBodyLength){
      alert(`文字数制限(${this.props.maxBodyLength})を超えました。超えた部分は削除されます。`);

      body = e.target.value.substring(0, this.props.maxBodyLength);
    }

    this.setState({ bodyLength: body.length });
    this.setState({ body: body});

  },
  handleOSChange: function (e) {
    this.setState({ os: e.target.value });
  },
  handleNotificationChange: function (e){

     this.setState({ isNotification: this.refs.isNotification.checked });
  },
  handleIsTestChange: function (e){

     this.setState({ isTest: this.refs.isTest.checked });
  },
  handleOnSend: function (e) {

    var self = this;

    this.setState({ sendButtonTxt: 'Sending...' });
    this.setState({ buttonDisabled: true });

    let isNotification = true;
    let isTest = false;

    if(process.env.NODE_ENV !== 'production'){
      if(!this.refs.isNotification.checked)
        isNotification = false;
    }

    if(this.refs.isTest && this.refs.isTest.checked)
      isTest = true;

    var data = {
      'title': this.state.title,
      'body': this.state.body,
      'os': this.state.os,
      'type': 1,
      'isNotification': isNotification,
      'isTest': isTest
    }

    $.ajax({
      url: this.props.pushNotificationUrl,
      type: "POST",
      dataType: 'json',
      contentType: "application/json",
      cache: false,
      data: JSON.stringify(data)
    }).done(function (msg) {

      self.refs.container.success(
        `有効: ${msg.result.success}、無効:${msg.result.failure}、処理時間:${msg.result.time}ms`,
        "正常に送信しました。", {
          timeOut: 3000,
          extendedTimeOut: 1000,
          closeButton: true
        });

      self.setState({ sendButtonTxt: 'Send' });
      self.setState({ buttonDisabled: false });

    }).fail(function (msg) {

      self.refs.container.error(
        msg.responseText,
        "送信失敗しました。", {
          timeOut: 3000,
          extendedTimeOut: 1000,
          closeButton: true
        });

      self.setState({ sendButtonTxt: 'Send' });
      self.setState({ buttonDisabled: false });

    });
  },
  render: function () {

    let testForm = "";
    let testSenderForm1 = "";
    let testSenderForm2 = "";

    if(this.props.isDev === '1'){

      testForm = <section>
              <div className="row">
                <div className="col col-6">
                  <label className="checkbox">
                    <input type="checkbox" name="checkbox" ref="isNotification" checked={this.state.isNotification} onChange={this.handleNotificationChange}/>
                    <i />お知らせ保存(テスト用：テスト環境のみ表示)</label>
                </div>
              </div>
            </section>;

      testSenderForm1 = <input type="checkbox" name="checkbox" ref="isTest" checked={this.state.isTest} onChange={this.handleIsTestChange}/>
      testSenderForm2 = <b> テスト送信  </b>;
    }

    return (

      <JarvisWidget colorbutton={false} editbutton={false} custombutton={false}>
        <header>
          <span className="widget-icon">
            <i className="fa fa-edit" />
          </span>
          <h2>Firebase Notification</h2>
        </header>
        {/* widget div*/}
        <div>
          {/* widget content */}
          <div className="widget-body no-padding">

              <div>

                <ToastContainer ref="container"
                  toastMessageFactory={ToastMessageFactory}
                  className="toast-top-right" />

                <form className="smart-form">
                  <header>
                    Send push notifacation {this.props.isDev === '1'
                      ? '(Dev)　'
                      : '　'}
                    (user：{this.props.notificationCount})　　
                    {testSenderForm1}{testSenderForm2}

                  </header>

                  <fieldset>

                    <section>
                      <label className="label">Title</label>
                      <label className="input">
                        <input type="text" className="input-xs" value={this.state.title} onChange={this.handleTitleChange} />
                      </label>
                    </section>

                    <section>
                      <label className="label">Body</label>
                      <label className="textarea">

                         <TextareaAutosize onResize={() => {}} rows="5" value={this.state.body} onChange={this.handleBodyChange}/>

                      </label>
                      <label className="label">({this.state.bodyLength}/{this.props.maxBodyLength})</label>
                    </section>

                    <section>
                      <label className="label">Select Group</label>
                      <label className="select">
                        <select className="input-sm" value={this.state.os} onChange={this.handleOSChange}>
                          <option value="0">All</option>
                          <option value="1">iOS</option>
                          <option value="2">Android</option>
                        </select>
                        <i />
                      </label>
                    </section>

                    {testForm}

                  </fieldset>

                  <footer>
                    <Button bsStyle="primary" disabled={this.state.buttonDisabled} onClick={this.handleOnSend}>{this.state.sendButtonTxt}
                    </Button>
                  </footer>
                </form>

              </div>
          </div>
        </div>
      </JarvisWidget>

    )
  }

});

export default PushSender



// WEBPACK FOOTER //
// ./src/components/notification/PushSender.js